import { useEffect, useRef, useState } from 'react';

const useTimer = (initialValue = 30) => {
  const [timer, setTimer] = useState(initialValue);
  const [resendDisabled, setResendDisabled] = useState(false);
  const ref = useRef(null);

  const start = () => {
    setResendDisabled(true);
    clearInterval(ref.current);
    ref.current = setInterval(() => {
      setTimer((prev) => {
        if (prev === 1) {
          clearInterval(ref.current);
          setResendDisabled(false);
          return initialValue;
        }
        return prev - 1;
      });
    }, 1000);
  };

  return {
    timer,
    start,
    resendDisabled,
  };
};

export default useTimer;
